// A content fingerprint used server-side to skip re-uploading a file that's
// already in this wedding's gallery. Photos are small enough to hash in full;
// for large videos, hashing the whole file would mean reading it entirely into
// memory (exactly what was just fixed for photo compression), so they use a
// lightweight size+timestamp+name fingerprint instead.
const LARGE_FILE_THRESHOLD = 20 * 1024 * 1024; // 20MB

export async function computeFingerprint(file) {
  const source =
    file.size <= LARGE_FILE_THRESHOLD
      ? await file.arrayBuffer()
      : new TextEncoder().encode(`${file.size}:${file.lastModified}:${file.name}`);
  const digest = await crypto.subtle.digest("SHA-256", source);
  return Array.from(new Uint8Array(digest)).map((b) => b.toString(16).padStart(2, "0")).join("");
}
